'use client'

export default function ClientLogger(props: any) {
    console.log('❌', props);

    return null
}